import { ReactElement } from 'react';

import { ErrorComponent } from '@/ui/error';

interface IErrorFallbackProps {
    resetErrorBoundary: () => void;
}

export function ErrorFallback({ resetErrorBoundary }: IErrorFallbackProps): ReactElement {
    return <ErrorComponent errorCode={500} onButtonClick={resetErrorBoundary} />;
}
